var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips__main-container"},[_c('TipsFilter'),_c('BetDataTable'),_c('TipsAnalysis'),(!_vm.isSponsorHidden)?_c('SponsorFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }